import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getCall } from "../utils/Network";
import Enroller from "../components/Enrolloer";
import Footer from "../components/Footer";
import Loader from "../components/Loader";
import "./css/Enroll.css";
import LanguageDropdown from "../components/LanguageDropdown";
import useQuery from "../components/hooks/useQuery";

const ApiKey = process.env.REACT_APP_API_KEY;

const Enroll = () => {
  const inputRef = useRef(null);
  let params = useParams();
  const query= useQuery();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const { token } = useParams();
  const { t } = useTranslation();
  const itemIdFromQuery = query.get("itemId") 
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (itemIdFromQuery) {
      sessionStorage.setItem("itemIdFromQuery", itemIdFromQuery);
    }
  }, [itemIdFromQuery]);

  const fnSetEmail = (event) => {
    setEmail(event.target.value);
  };

  Enroller();
  const enrollerCode = params.enrollerCode;

  const location = useLocation();

  useEffect(() => {
    const html = document.getElementsByTagName("html")[0];
    html.setAttribute("data-wf-page", "68603f7a056ff6f78f58cb16");
    html.setAttribute("data-wf-site", "68603f7a056ff6f78f58cab1");
    window.Webflow && window.Webflow.destroy();
    window.Webflow && window.Webflow.ready();
    window.Webflow && window.Webflow.require("ix2").init();
    document.dispatchEvent(new Event("readystatechange"));
  }, []);

  useEffect(() => {
    if (token) {
      sessionStorage.setItem("token", token);
    }
  }, [token]);

    useEffect(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, []);

  async function fnValidate() {
    const regEx = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

    if (email === "") {
      setMessage(t("pleaseEnterYourEmail"));
      return false;
    } else if (!regEx.test(email)) {
      setMessage(t("invalidEmail"));
      return false;
    }

    const myHeaders = {
      "API-key": ApiKey,
    };

    const id = 0;
    try {
      setIsLoading(true);
      let response = await getCall({
        url: "validateAssociateEmail",
        urlParams: { associateId: id, email },
        header: myHeaders,
      });

      if (response && response?.data?.isValid) {
        setIsLoading(false);
        navigate("/" + enrollerCode + "/signup?email=" + email);
      } else {
        setIsLoading(false);
        navigate("/signin?email=" + email);
        return false;
      }
    } catch (error) {
      setIsLoading(false);
      console.log("error:", error);
    }

    setMessage("");
  }

  const checkKeyPress = (e) => {
    if (e?.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
      fnValidate();
    }
  };

  return (
    <>
      {isLoading && <Loader />}
      <div className="img-bg">
        <div className="enrollment-navbar">
          <div className="noa-logo colored-logo"></div>
          <LanguageDropdown />
        </div>
        <div className="dark-mode">
          <div className="main-join-now">
            <div>
              <div className="heading-enroll">{t("enterYour")}</div>
              <h2 className="email_test">{t("emailaddress")}</h2>
            </div>
            <form action="/enrollment" onSubmit={() => false}>
              <div className="input-wrapper">
                <div className="errormsg-wrapper">
                  <p className="enter-referral">{t("enterYourEmailAddress")}</p>
                  <input
                    ref={inputRef}
                    type="text"
                    placeholder={t("enterYourEmailAddress")}
                    className="input-join"
                    maxLength={50}
                    onKeyDown={(e) => {
                      checkKeyPress(e);
                    }}
                    onChange={fnSetEmail}
                  />
                  <div className="err-message">
                    <small>{message}</small>
                  </div>
                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <div className="navbar-button-wrapper btn-custom-signup">
                  <div className="primary-button-wrapper">
                    <a
                      href="#"
                      onKeyDown={(e) => {
                        checkKeyPress();
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        fnValidate();
                      }}
                      data-w-id="3af1c84f-ff74-c014-cb3b-40446b73b1f6"
                      className="primary-button w-inline-block"
                    >
                      <div className="primary-button-border-wrap">
                        <div className="primary-button-wrap">
                          <div className="primary-button-text">
                            {t("continue")} &nbsp;&nbsp;➜
                          </div>
                          <div className="primary-button-hover-text">
                            {t("continue")} &nbsp;&nbsp;➜
                          </div>
                          <div className="primary-button-hover-bg"></div>
                        </div>
                      </div>
                      <div className="line-wrap">
                        <div className="primary-line-wrap _1">
                          <div className="line _1"></div>
                          <div className="line _2"></div>
                        </div>
                        <div className="primary-line-wrap _2">
                          <div className="line _3"></div>
                          <div className="line _4"></div>
                        </div>
                        <div className="primary-line-wrap _3">
                          <div className="line _5"></div>
                          <div className="line _6"></div>
                        </div>
                        <div className="primary-line-wrap _4">
                          <div className="line _7"></div>
                          <div className="line _8"></div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="menu-button w-nav-button">
                    <div
                      data-is-ix2-target="1"
                      className="hamburger-menu-icon"
                      data-w-id="b58e0106-6be1-80f9-2e9e-29cc3a30b8aa"
                      data-animation-type="lottie"
                      data-src="/images/hamburger-20menu.lottie"
                      data-loop="0"
                      data-direction="1"
                      data-autoplay="0"
                      data-renderer="svg"
                      data-duration="0"
                      data-ix2-initial-state="0"
                    >
                      <span style={{ color: "#ffffff" }}>
                        <img
                          src="/images/Hamburger_icon.png"
                          alt=""
                          style={{ width: "30%" }}
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Enroll;
